import type { LucideIcon } from 'lucide-react';

interface Props {
  icon: LucideIcon;
  title: string;
  text?: string;
  action?: { label: string; onClick: () => void };
}

/** Оформленное «пусто / нет доступа / ошибка» вместо голого текста. */
export function EmptyState({ icon: Icon, title, text, action }: Props) {
  return (
    <div className="empty flex flex-col items-center gap-3">
      <span className="size-16 rounded-3xl bg-accent-soft text-accent grid place-items-center">
        <Icon className="size-8" aria-hidden />
      </span>
      <p className="text-lg font-semibold text-fg">{title}</p>
      {text && <p className="text-sm max-w-xs">{text}</p>}
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className="min-h-11 px-5 mt-1 rounded-xl border border-line2 font-semibold text-fg active:bg-surface2"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
